import {
  Container,
  Row,
  Col,
} from "react-bootstrap";

const AboutSection = ({ aboutSection, themeColor }) => {

  return (
    <div style={{background: `linear-gradient(180deg, ${themeColor} -700%, #eef2ff30)`}}>
      <Container id="about" className="py-5">
        <Row className="mb-4 text-center">
          <Col>
            <h2 className="fw-bold">{aboutSection?.aboutTitle || "About"}</h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md={9} className="fs-5 text-muted text-center">
            {aboutSection?.about}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default AboutSection;
